





import { Vue } from 'vue-property-decorator';
export default class TermsOfService extends Vue {}
